<template>
  <RouterView />

  <RouterNavigationProgress />
</template>

<script lang="ts" setup>
  import { onMounted } from 'vue';

  import applyAuthSecretTokenToLocation from '@/features/authentication/applyAuthSecretTokenToLocation';
  import useAuthenticationAndLicenseGuard from '@/features/authentication/authentication-guard/useAuthenticationAndLicenseGuard';
  import loadCurrentUserRoleOnMount from '@/features/authentication/current-user/loadCurrentUserRoleOnMount';
  import useAuthSecretToken from '@/features/authentication/useAuthSecretToken';
  import initializeColorTheme from '@/features/color-theme/initializeColorTheme';
  import onSystemColorThemeChanged from '@/features/color-theme/onSystemColorThemeChanged';
  import applyDebugCheckerBasedOnMonitorDebugSettingsToDefaultLogger from '@/features/debug/applyDebugCheckerBasedOnMonitorDebugSettingsToDefaultLogger';
  import logRouterNavigation from '@/features/debug/logRouterNavigation';
  import useFacebookPageRouterGuard from '@/features/facebook/useFacebookPageRouterGuard';
  import useUpdatePageRouterGuard from '@/features/version-update/update-page/useUpdatePageRouterGuard';
  import { useUiSettings } from '@/ui/ui-appearance-selector/utils/useUiSettings';

  import RouterNavigationProgress from '@/features/router-navigation-progress/RouterNavigationProgress.vue';

  applyDebugCheckerBasedOnMonitorDebugSettingsToDefaultLogger();

  loadCurrentUserRoleOnMount();

  useAuthenticationAndLicenseGuard();

  logRouterNavigation();

  useUpdatePageRouterGuard();
  useFacebookPageRouterGuard();

  initializeColorTheme();

  onSystemColorThemeChanged(() => {
    initializeColorTheme();
  });

  onMounted(() => {
    const { initUiSettings } = useUiSettings();
    initUiSettings();
  });

  const { authSecretToken } = useAuthSecretToken();

  applyAuthSecretTokenToLocation(authSecretToken);
</script>

<style lang="scss">
  @use 'sass:meta';
  @include meta.load-css('../scss/global');
</style>
